import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Account ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Updates ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Messages ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Tasks ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Comments ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Profile ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Payments ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Projects ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Lock Account ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Logout ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CAvatar = _resolveComponent("CAvatar")!
  const _component_CDropdownToggle = _resolveComponent("CDropdownToggle")!
  const _component_CDropdownHeader = _resolveComponent("CDropdownHeader")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CBadge = _resolveComponent("CBadge")!
  const _component_CDropdownItem = _resolveComponent("CDropdownItem")!
  const _component_CDropdownDivider = _resolveComponent("CDropdownDivider")!
  const _component_CDropdownMenu = _resolveComponent("CDropdownMenu")!
  const _component_CDropdown = _resolveComponent("CDropdown")!

  return (_openBlock(), _createBlock(_component_CDropdown, { variant: "nav-item" }, {
    default: _withCtx(() => [
      _createVNode(_component_CDropdownToggle, {
        placement: "bottom-end",
        class: "py-0",
        caret: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CAvatar, {
            src: $setup.avatar,
            size: "md"
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_component_CDropdownMenu, { class: "pt-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_CDropdownHeader, {
            component: "h6",
            class: "bg-light fw-semibold py-2"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-bell" }),
              _hoisted_2,
              _createVNode(_component_CBadge, {
                color: "info-gradient",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-envelope-open" }),
              _hoisted_3,
              _createVNode(_component_CBadge, {
                color: "success-gradient",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-task" }),
              _hoisted_4,
              _createVNode(_component_CBadge, {
                color: "danger-gradient",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-comment-square" }),
              _hoisted_5,
              _createVNode(_component_CBadge, {
                color: "warning-gradient",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownHeader, {
            component: "h6",
            class: "bg-light fw-semibold py-2"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-user" }),
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-settings" }),
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-dollar" }),
              _hoisted_9,
              _createVNode(_component_CBadge, {
                color: "secondary",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-file" }),
              _hoisted_10,
              _createVNode(_component_CBadge, {
                color: "primary-gradient",
                class: "ms-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.itemsCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownDivider),
          _createVNode(_component_CDropdownItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-shield-alt" }),
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_CDropdownItem, { onClick: $options.logout }, {
            default: _withCtx(() => [
              _createVNode(_component_CIcon, { icon: "cil-lock-locked" }),
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}